/**
 * A definition of the log levels used in the player.
 *
 * @remarks
 * Logging is handled similar to other libraries, where a higher log level includes all lower log levels.
 *
 * This should only be used for debugging purposes.
 * The log level should be set to `LogLevel.None` in production, which is the default.
 */
export const LogLevel = {
  None: 0,
  Error: 10,
  Warn: 20,
  Info: 30,
  Debug: 40,
  Trace: 50,
};

/**
 * {@inheritDoc LogLevel:var}
 */
export type LogLevel = (typeof LogLevel)[keyof typeof LogLevel];
